import React from 'react';
import DynamicForm from '../../../forms/components/DynamicForm';

const TaskGeneralForm = ({ task, onClose, onSuccess }) => {
  const handleSuccess = (formResponseData) => {
    // formResponseData is available but not needed for general forms
    // The form data was already sent to /api/tasks/${task.id}/form-completed

    // Cerrar el modal inmediatamente para evitar múltiples envíos
    onClose();
    // Ejecutar el callback del padre
    onSuccess();
  };

  return (
    <DynamicForm
      task={task}
      formType="general"
      onClose={onClose}
      onSuccess={handleSuccess}
      title={`Información General - ${task.client?.name || task.client?.email || 'Cliente'}`}
      submitButtonText="Guardar e Iniciar"
    />
  );
};

export default TaskGeneralForm;

